import { Link } from '@/components/LocalizedLink';
import { useLanguage } from '@/contexts/LanguageContext';
import type { AuthorityAsset } from '@/lib/authorityAssetCatalog';
import { localizeAuthorityAssetText } from '@/lib/authorityAssetCatalog';

type RelatedPlaybooksBlockProps = {
  assets: AuthorityAsset[];
  title?: string;
};

const RelatedPlaybooksBlock = ({ assets, title }: RelatedPlaybooksBlockProps) => {
  const { lang } = useLanguage();

  if (!assets.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="font-display text-3xl font-bold text-foreground mb-6">
        {title || (lang === 'tr' ? 'İlgili Playbook Rehberleri' : 'Related Playbook Guides')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {assets.map((asset) => (
          <Link
            key={asset.slug}
            to={`/playbooks/${asset.slug}`}
            className="rounded-xl border border-border/70 p-5 bg-card/40 hover:bg-card transition-colors"
          >
            <p className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-2">
              {lang === 'tr' ? 'Authority Asset' : 'Authority Asset'}
            </p>
            <h3 className="font-display text-xl text-foreground mb-2 line-clamp-2">
              {localizeAuthorityAssetText(asset.title, lang)}
            </h3>
            <p className="font-body text-sm text-muted-foreground leading-relaxed line-clamp-3">
              {localizeAuthorityAssetText(asset.summary, lang)}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPlaybooksBlock;
